import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{! template-lint-disable }}\n<p data-test-content>\n  This works,\n  {{this.model.id}}\n</p>")